module.exports = __webpack_public_path__ + "static/agatawork3-38b054cf547485c4240731413b4bafe3.jpg";